import * as React from "react";

const Upload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer17"
      fill="none"
      stroke="#000"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeWidth="0.4"
    >
      <path
        id="rect77"
        d="M3.12 1.74a1.7 1.7 0 0 0-1.612 1.168.23.23 0 0 1-.114.125C.871 3.263.53 3.78.53 4.358v.015c0 .8.648 1.448 1.448 1.448h2.666c.65 0 1.178-.528 1.178-1.178v-.025c0-.523-.343-.974-.83-1.125a.26.26 0 0 1-.177-.217c-.061-.56-.55-1.536-1.693-1.536Z"
        opacity="1"
        transform="translate(0 -.605)"
      ></path>
      <path
        id="path90"
        fillOpacity="1"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="M3.175 4.35V2.628"
        opacity="1"
      ></path>
      <path
        id="path92"
        fillOpacity="1"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="m2.53 2.827.557-.624a.117.117.091 0 1 .176 0l.553.624"
        opacity="1"
        transform="translate(0 .247)"
      ></path>
    </g>
  </svg>
);

export default Upload;
